<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs">
	<div class="cards-holder">
		<div class="sem-calls-r11">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div class="graph-div">
				<div class="c-portlet__header">
					<div class="o-stack__cell">
						<h5 class="title primary-color">
							{{ sectiontitle }}
							<span class="download-icon" *ngIf="hasData">
								<a
									href="javascript:void(0)"
									(click)="downloadCSV()"
									target="_blank"
									*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
								>
									<i class="fa fa-download" aria-hidden="true"></i>
								</a>
							</span>
						</h5>
					</div>
				</div>
				<div *ngIf="!hasData" class="no-data-min-ht">
					<div>No Data to Display</div>
				</div>
				<div class="calls-graph-area" [hidden]="!hasData">
					<div>
						<div class="graph-title">Times and Durations of Calls</div>
						<div class="graph-filter">
							<div class="filterLabel" [ngClass]="{ 'answered-inactive': graphFilterDisabled }">
								<span>Filter Answered Calls:</span>
							</div>
							<div [ngClass]="{ 'graph-filter-option': true, 'answered-inactive': graphFilterDisabled }">
								<select
									(change)="filterChange($event.target.value)"
									[disabled]="graphFilterDisabled"
									class="primary-outline-color"
								>
									<option
										*ngFor="let item of graphFilterOptions"
										value="{{ item?.id }}"
										[selected]="item.id == selectedValue"
									>
										{{ item?.name }}
									</option>
								</select>
								<i class="fa fa-angle-down"></i>
							</div>
							<div class="date-range">
								{{ dateRange }}
							</div>
						</div>
					</div>

					<div>
						<div id="chart" #graphArea></div>
						<div class="calls-data">
							<div class="call-metrics">
								<div class="item">
									Total Number of Answered Calls&nbsp;&nbsp;&nbsp;&nbsp;<span>{{
										metricsData.answeredCalls | number
									}}</span>
								</div>
								<div class="item">
									Total Number of Missed Calls&nbsp;&nbsp;&nbsp;&nbsp;<span>{{
										metricsData.missedCalls | number
									}}</span>
								</div>
								<div class="item">
									Avg. Duration (HH:MM:SS)&nbsp;&nbsp;&nbsp;&nbsp;<span>{{
										metricsData.avgDuration
									}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
